import ServiceCard from "./ServiceCard";
import { useState, useEffect } from "react";
import Funnel from "./Funnel";


export default function Services() {
	
const [activeFunnel, setActiveFunnel] = useState(null);

const services = [
  {
    icon: (
      /*<svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"/>
      </svg>*/
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"/>
      </svg>	  
    ),
    title: "Financial Planning",
    description: "Build your roadmap to financial security."
  },
  /*{
    icon: (
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"/>
      </svg>
    ),
    title: "Investment Advisory",
    description: "Customized portfolios aligned with goals."
  },*/
  {
    icon: (
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"/>
      </svg>
    ),
    title: "Insurance Strategies",
    description: "Protection plans for life’s uncertainties."
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
		<path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
	</svg>

    ),
	title: "Health Insurance",
    description: "Taking care of your health."
  },
  /*{
    icon: (
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"/>
      </svg>
    ),
    title: "Final Expenses",
    description: "Celebrating life."
  },
  {
    icon: (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
			<path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
		</svg>

	  
    ),
    title: "Mortgage Protection",
    description: "Ensure your mortgage is covered if life takes a turn"
  },
  {
    icon: (
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"/>
      </svg>
    ),
    title: "Indexed Universal Life",
    description: "Guranteed growth with living benefits."
  },
  
    {
    icon: (
      
      <svg fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" className="w-8 h-8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"/>
	  </svg>
    ),
    title: "Annuities",
    description: "Guranteed lifetime income."
  }*/
];




const handleFunnelSubmit = async ({ answers, token }) => {
  console.log("Submitted answers:", answers);
  // You can post to backend here
  setActiveFunnel(null);
};

useEffect(() => {
  document.body.style.overflow = activeFunnel ? 'hidden' : 'auto';
  return () => (document.body.style.overflow = 'auto');
}, [activeFunnel]);

  return (
    <section id="services" className="px-6 py-20">
      <h2 className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">What We Offer</h2>
      <p className="mx-auto mb-12 max-w-3xl text-center text-3xl font-bold leading-tight text-white md:text-5xl">Planning tools for protection, liquidity, and long-term confidence.</p>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
		{services.map(s => (
		  <ServiceCard
			key={s.title}
			{...s}
			onClick={() => setActiveFunnel(s.title)}
		
		  />
		))}
      </div>
	{activeFunnel && (
	  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 px-4 backdrop-blur transition-all duration-300">
		<div className="relative">
		  <button
			className="absolute -right-4 -top-4 flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-950 shadow-lg hover:bg-cyan-100"
			onClick={() => setActiveFunnel(null)}
		  >
			✕
		  </button>
		  <Funnel funnelName={activeFunnel} onSubmit={handleFunnelSubmit} />

		</div>
	  </div>
	)}  

      

    </section>
  );
}